import { render, staticRenderFns } from "./showImgs.vue?vue&type=template&id=a4aeef02&scoped=true"
import script from "./showImgs.vue?vue&type=script&lang=js"
export * from "./showImgs.vue?vue&type=script&lang=js"
import style0 from "./showImgs.vue?vue&type=style&index=0&id=a4aeef02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aeef02",
  null
  
)

export default component.exports